import { postData } from '../../helpers/fetch'
import { globalEmitter } from '../helpers/emitter'

const getLineItem = (id: number, properties: {}, quantity: number) => {
  const data = {
    items: [
      {
        id,
        properties,
        quantity
      }
    ]
  }
  return data
}

export const addCartItem = async (id: number, properties = {}, quantity = 1) => {
  try {
    const lineItem = getLineItem(id, properties, quantity)
    const item = await postData('/cart/add.js', lineItem, 'json')
    return item
  } catch (error) {
    throw error
  }
}

export const addMultipleCartItems = async (items: any) => {
  try {
    return await postData('/cart/add.js', items, 'json')
  } catch (error) {
    throw error
  }
}
